import { render, staticRenderFns } from "./ChatbotTranscriptModal.vue?vue&type=template&id=20dfe8e8&scoped=true"
import script from "./ChatbotTranscriptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatbotTranscriptModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatbotTranscriptModal.vue?vue&type=style&index=0&id=20dfe8e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dfe8e8",
  null
  
)

export default component.exports